import {PaymentProviderEnum} from "../shared/types/PaymentProviderEnum.ts";

type StartParam = 'backend_en' | 'backend_ru'

const providers: Record<StartParam, PaymentProviderEnum[]> = {
    backend_en: [PaymentProviderEnum.STARS],
    backend_ru: [PaymentProviderEnum.YOOCASSA, PaymentProviderEnum.STARS],
}

export const getPaymentProviders = (): PaymentProviderEnum[] => {
    try {
        const urlParams = new URLSearchParams(window.location.search);
        const startParam = urlParams.get('startapp') as StartParam;

        return providers[startParam] || [];
    } catch (error) {
        console.error('Failed to retrieve payment providers:', error);
        return providers.backend_ru;
    }
};
